// eslint-disable-next-line import/no-extraneous-dependencies
import {____private_editorStore} from '@theatre/r3f'
import create from 'zustand'

const useExtensionStore = create(____private_editorStore)

export default useExtensionStore
